export default {
  slug: "exposed",
  code: "EXP",
  label: "Exposed",
  isKED: true,
  hasSubtitle: true,
  hasSubtitle2: true,
  logoFamily: "jb",
};
